import { AGENT_ROUTES } from "../config/agentPortal";

export interface AgentBookingsLocationState {
  /** Query string from the bookings list (without leading `?`). */
  agentBookingsReturnSearch?: string;
}

export const agentBookingsDetailNavigateOptions = (
  returnSearch: string
): { state: AgentBookingsLocationState } => ({
  state: { agentBookingsReturnSearch: returnSearch },
});

export const getAgentBookingsReturnPath = (
  state: unknown,
  fallback = AGENT_ROUTES.bookings
): string => {
  const search = (state as AgentBookingsLocationState | null)
    ?.agentBookingsReturnSearch;
  if (!search?.trim()) return fallback;
  return `${AGENT_ROUTES.bookings}?${search}`;
};
